var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"block":"","dark":"","color":"blue"},on:{"click":function($event){_vm.showCompose = true}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v(" Compose ")],1),_c('ComposeMail',{model:{value:(_vm.showCompose),callback:function ($$v) {_vm.showCompose=$$v},expression:"showCompose"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }